import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import { post } from "../../../helpers/api_helper";
import swal from "sweetalert";
import { Spin } from "antd";
import {
  POST_FilmsInsert,
  POST_FilmsUpdate,
  POST_GetFilmsDetailByID,
} from "../../../helpers/url_helper";
import {
  successMessage,
  errorMessage,
  capitalizeString,
} from "../CommonFunctions";

const AddFilms = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    Length_Inch: Yup.string().trim().required("Length Inch is required field"),
    Width_Inch: Yup.string().trim().required("Width Inch is required field"),
    FilmName: Yup.string().trim().required("Film Name is required field"),
  });

  useEffect(() => {
    if (PrimaryIdParam) {
      getFilmsDetailsByID();
    }
  }, []);

  const getFilmsDetailsByID = () => {
    setIsLoading(true);
    post(POST_GetFilmsDetailByID, {
      FilmsIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      FilmsIDEncrypted: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      FilmName: "",
      Length_Inch: "",
      Width_Inch: "",
      Length_CM: "",
      Width_CM: "",
    },
    validateOnBlur: false,
  });

  // useEffect(() => {
  //   const { Length_Inch, Width_Inch } = formik.values;

  //   if (Length_Inch && !isNaN(Length_Inch)) {
  //     const lengthCm = (parseFloat(Length_Inch) * 2.54).toFixed(2);
  //     formik.setFieldValue("Length_CM", lengthCm);
  //   }

  //   if (Width_Inch && !isNaN(Width_Inch)) {
  //     const widthCm = (parseFloat(Width_Inch) * 2.54).toFixed(2);
  //     formik.setFieldValue("Width_CM", widthCm);
  //   }

  //   if (Length_Inch && Width_Inch) {
  //     const filmNameValue = `${Length_Inch} x ${Width_Inch}`;
  //     formik.setFieldValue("FilmName", filmNameValue);
  //   }
  // }, [formik.values.Length_Inch, formik.values.Width_Inch]);

  const {
    values: { Length_Inch, Width_Inch },
  } = formik;

  const [isLenthOrWidthChanged, setIsLengthOrWidthChanged] = useState(false);

  useEffect(() => {
    if (isLenthOrWidthChanged) {
      if (Length_Inch && !isNaN(Length_Inch)) {
        const lengthCm = (parseFloat(Length_Inch) * 2.54).toFixed(2);
        formik.setFieldValue("Length_CM", lengthCm);
      }

      if (Width_Inch && !isNaN(Width_Inch)) {
        const widthCm = (parseFloat(Width_Inch) * 2.54).toFixed(2);
        formik.setFieldValue("Width_CM", widthCm);
      }

      if (Length_Inch && Width_Inch) {
        const filmNameValue = `${Length_Inch} x ${Width_Inch}`;
        formik.setFieldValue("FilmName", filmNameValue);
      }
      setIsLengthOrWidthChanged(false);
    }
  }, [isLenthOrWidthChanged]);

  const handleValidSubmit = (values) => {
    setIsLoading(true);

    let payload = {
      ...values,
      FilmName: values.FilmName.trim(),
      Length_Inch: values.Length_Inch.trim(),
      Width_Inch: values.Width_Inch.trim(),
      Length_CM: values.Length_CM.trim(),
      Width_CM: values.Width_CM.trim(),
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(PrimaryIdParam ? POST_FilmsUpdate : POST_FilmsInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          // swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/films");
          }, 1000);
        } else {
          // swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Films
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={3}>
                      <Field
                        type="number"
                        label="Length (Inch)"
                        name="Length_Inch"
                        placeholder={"Enter Length (Inch)"}
                        component={CustomInput}
                        maxLength={150}
                        required
                        onChange={(e) => {
                          formik.setFieldValue("Length_Inch", e?.target?.value);
                          setIsLengthOrWidthChanged(true);
                        }}
                        autoFocus
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="number"
                        label={"Width (Inch)"}
                        name="Width_Inch"
                        placeholder={"Enter Width (Inch)"}
                        component={CustomInput}
                        onChange={(e) => {
                          formik.setFieldValue("Width_Inch", e?.target?.value);
                          setIsLengthOrWidthChanged(true);
                        }}
                        required
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Film Name"
                        name="FilmName"
                        placeholder={"Enter Film Name"}
                        component={CustomInput}
                        required
                        maxLength={250}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "FilmName",
                            capitalizeString(e?.target?.value),
                          );
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="text"
                        label={"Length (CM)"}
                        name="Length_CM"
                        placeholder={"Enter Length (CM)"}
                        component={CustomInput}
                        readOnly
                        onChange={(e) => {
                          formik.setFieldValue("Length_CM", e?.target?.value);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={9}>
                      <Row>
                        <Col lg={3}>
                          <Field
                            type="text"
                            label={"Width (CM)"}
                            name="Width_CM"
                            placeholder={"Enter Width (CM)"}
                            component={CustomInput}
                            readOnly
                            onChange={(e) => {
                              formik.setFieldValue(
                                "Width_CM",
                                e?.target?.value,
                              );
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={3}></Col>
                  </Row>
                  <hr className="mt-1 mb-2"></hr>
                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default AddFilms;
